
interface Idata {
  ok: boolean,
  message: string
} 

export function beforeUpload(file: File): Idata {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    return {
      ok: false,
      message: "You can only upload JPG/PNG file!"
    }
  }
  const isLt1M = file.size / 1024 / 1024 < 1;
  if (!isLt1M) {
    return {
      ok: false,
      message: "Image must smaller than 1MB!"
    }
  }
  return {
    ok: true,
    message: "Success"
  };
}